import React, { useEffect, useState } from 'react';
// 胜平负 → 火焰 emoji（与 matchResultDisplay 保持一致）
const convertTypeToBar = (type, index) => {
    let filter = '';
    let glow = '';

    switch (type) {
        case 'win':
            // 红色火焰 — 胜利 (低饱和度)
            filter = 'hue-rotate(0deg) saturate(1.1) brightness(0.9)';
            glow = '0 0 3px rgba(255, 60, 40, 0.3)';
            break;
        case 'draw':
            // 灰白色火焰 — 平局 (静谧)
            filter = 'grayscale(1) brightness(1.0) opacity(0.6)';
            glow = 'none';
            break;
        case 'fail':
            // 蓝色火焰 — 失败 (清冷)
            filter = 'hue-rotate(200deg) saturate(1.2) brightness(1.0)';
            glow = '0 0 3px rgba(30, 100, 255, 0.3)';
            break;
        default:
            return null;
    }

    return (
        <span
            key={index}
            title={type === 'win' ? '胜' : type === 'draw' ? '平' : '败'}
            style={{
                fontSize: '13px',
                lineHeight: 1,
                display: 'inline-block',
                filter: filter,
                textShadow: glow,
                margin: '0 -1px', // 紧凑排列
                flexShrink: 0,
                width: '10px',
                transform: 'scaleX(0.75)', // 水平压缩
                transformOrigin: 'center center'
            }}
        >
            🔥
        </span>
    );
};

const processSinglePersonData = (records, count, trendType) => {
    if (!records || records.length === 0) return null;

    // 1. 按时间升序
    const sorted = [...records].sort(
        (a, b) => new Date(a.time) - new Date(b.time)
    );

    // 2. 这里支持自动检测趋势类型，如果传入了 trendType 则使用指定的
    const types = trendType ? [trendType] : ['unbeaten', 'winless'];
    let bestTrend = [];

    types.forEach(type => {
        const isSameTrend =
            type === 'unbeaten'
                ? (t) => t === 'win' || t === 'draw'   // 不败
                : (t) => t === 'fail' || t === 'draw'; // 不胜

        const currentTrend = [];
        for (let i = sorted.length - 1; i >= 0; i--) {
            const matchType = sorted[i].type;
            if (isSameTrend(matchType)) {
                currentTrend.unshift(matchType); // 旧 → 新
            } else {
                break;
            }
        }

        if (currentTrend.length >= (count || 3) && currentTrend.length > bestTrend.length) {
            bestTrend = currentTrend;
        }
    });

    if (bestTrend.length === 0) return null;

    return {
        trend: bestTrend,
        count: bestTrend.length
    };
};

const GetSinglePersonFire = ({
    records,      // 单个人的比赛记录
    count,        // 要求的最低场数
    trendType     // 可选：'unbeaten' | 'winless'
}) => {
    const [fireData, setFireData] = useState(null);

    useEffect(() => {
        setFireData(processSinglePersonData(records, count, trendType));
    }, [records, count, trendType]);

    if (!fireData || !fireData.trend || fireData.trend.length === 0) return null;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center', // Center the bars
                width: '100%',
                height: '100%', // Fill parent height
                overflow: 'hidden', // No scroll
            }}
            className="fire-icons-container"
        >
            {fireData.trend.map((type, index) =>
                convertTypeToBar(type, index)
            )}
        </div>
    );
};

export default GetSinglePersonFire;
